import { render, staticRenderFns } from "./TianKeXiao.vue?vue&type=template&id=1f725ded&scoped=true&"
import script from "./TianKeXiao.vue?vue&type=script&lang=js&"
export * from "./TianKeXiao.vue?vue&type=script&lang=js&"
import style0 from "./TianKeXiao.vue?vue&type=style&index=0&id=1f725ded&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f725ded",
  null
  
)

export default component.exports